var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpWould(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72917 15.0179H8.33333C5.16667 15.0179 3.58333 14.2262 3.58333 10.2679V6.30957C3.58333 3.1429 5.16667 1.55957 8.33333 1.55957H14.6667C17.8333 1.55957 19.4167 3.1429 19.4167 6.30957V10.2679C19.4167 13.4346 17.8333 15.0179 14.6667 15.0179H14.2708C14.0254 15.0179 13.7879 15.1367 13.6375 15.3346L12.45 16.9179C11.9275 17.6146 11.0725 17.6146 10.55 16.9179L9.36249 15.3346C9.23582 15.1604 8.95083 15.0179 8.72917 15.0179Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWould);
export default __webpack_public_path__ + "static/media/help_would.003494466ea2620f332b1072006f1fb5.svg";
export { ForwardRef as ReactComponent };